// extracted by mini-css-extract-plugin
module.exports = {"flx_flex":"public-components_flx_flex__wLWOH"};